import script from "./help-table-row.vue?vue&type=script&setup=true&lang=ts"
export * from "./help-table-row.vue?vue&type=script&setup=true&lang=ts"

import "./help-table-row.vue?vue&type=style&index=0&id=391b4ca0&lang=scss"

const __exports__ = script;

export default __exports__